var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDirty)?_c('mj-nothing-found'):_c('mj-ready-for-search')}
var staticRenderFns = []

export { render, staticRenderFns }